import { SheetData } from "x-data-spreadsheet";

export const StructureTableNumbersSampleData: SheetData = {
    rows: {
        0: { cells: { 0: { text: "Fruit" }, 1: { text: "AC" } } },
        1: { cells: { 0: { text: "Oranges" }, 1: { text: "170" } } },
        2: { cells: { 0: { text: "Lemons" }, 1: { text: "168" } } },
        3: { cells: { 0: { text: "Bananas" }, 1: { text: "150" } } },
        4: { cells: { 0: { text: "Kiwi" }, 1: { text: "140" } } },
        5: { cells: { 0: { text: "Apples" }, 1: { text: "138" } } },
        6: { cells: { 0: { text: "Melons" }, 1: { text: "145" } } },
        7: { cells: { 0: { text: "Pears" }, 1: { text: "120" } } },
        8: { cells: { 0: { text: "Grapes" }, 1: { text: "110" } } },
    },
};

export const StructureTableNumbersCommentData: SheetData = {
    rows: {
        0: { cells: { 0: { text: "Comments" } } },
        1: {
            cells: {
                0: {
                    text: "Oranges volume will be increased in the next quarter. Contracts signed with new suppliers in Southern Europe to meet the increased demand.",
                },
            },
        },
        3: { cells: { 0: { text: "South American supply has dropped by 10% due to a temporary export ban." } } },
        8: {
            cells: {
                0: { text: "The demand is gradually increasing just before spring/summer season. Evaluate new suppliers." },
            },
        },
    },
};

export const StructureTableChartSampleData: SheetData = {
    rows: {
        0: { cells: { 0: { text: "Fruit" }, 1: { text: "AC" } } },
        1: { cells: { 0: { text: "Oranges" }, 1: { text: "170" } } },
        2: { cells: { 0: { text: "Lemons" }, 1: { text: "168" } } },
        3: { cells: { 0: { text: "Bananas" }, 1: { text: "150" } } },
        4: { cells: { 0: { text: "Kiwi" }, 1: { text: "140" } } },
        5: { cells: { 0: { text: "Apples" }, 1: { text: "138" } } },
        6: { cells: { 0: { text: "Melons" }, 1: { text: "145" } } },
        7: { cells: { 0: { text: "Pears" }, 1: { text: "120" } } },
        8: { cells: { 0: { text: "Grapes" }, 1: { text: "110" } } },
    },
};

export const StructureTableChartCommentData: SheetData = {
    rows: {
        0: { cells: { 0: { text: "Comments" } } },
        1: {
            cells: {
                0: {
                    text: "Oranges volume will be increased in the next quarter. Contracts signed with new suppliers in Southern Europe to meet the increased demand.",
                },
            },
        },
        3: { cells: { 0: { text: "South American supply has dropped by 10% due to a temporary export ban." } } },
        8: {
            cells: {
                0: { text: "The demand is gradually increasing just before spring/summer season. Evaluate new suppliers." },
            },
        },
    },
};

/**
 * POC only: a wide long-format sample for the Data fields pane (same as the Charts one). Month is the category, Region the group column, Product
 * line a spare dimension, AC / PY / PL / FC the measures, Comments by header and Notes a text column that can be
 * dropped on Comments.
 */
export const TestingColumnsSampleData: SheetData = {
    rows: {
        0: {
            cells: {
                0: { text: "Month" },
                1: { text: "Region" },
                2: { text: "Product line" },
                3: { text: "AC" },
                4: { text: "PY" },
                5: { text: "PL" },
                6: { text: "FC" },
                7: { text: "Comments" },
                8: { text: "Notes" },
            },
        },
        1: {
            cells: {
                0: { text: "Jan" },
                1: { text: "Europe" },
                2: { text: "Audio" },
                3: { text: "129" },
                4: { text: "133" },
                5: { text: "110" },
                6: { text: "124" },
                7: { text: "Strong start in Europe after the January campaign." },
                8: { text: "" },
            },
        },
        2: {
            cells: {
                0: { text: "Jan" },
                1: { text: "Europe" },
                2: { text: "Mobile" },
                3: { text: "124" },
                4: { text: "124" },
                5: { text: "103" },
                6: { text: "157" },
                7: { text: "" },
                8: { text: "" },
            },
        },
        3: {
            cells: {
                0: { text: "Jan" },
                1: { text: "America" },
                2: { text: "Audio" },
                3: { text: "139" },
                4: { text: "134" },
                5: { text: "128" },
                6: { text: "166" },
                7: { text: "" },
                8: { text: "" },
            },
        },
        4: {
            cells: {
                0: { text: "Jan" },
                1: { text: "America" },
                2: { text: "Mobile" },
                3: { text: "146" },
                4: { text: "121" },
                5: { text: "146" },
                6: { text: "140" },
                7: { text: "" },
                8: { text: "Check with sales ops." },
            },
        },
        5: {
            cells: {
                0: { text: "Jan" },
                1: { text: "Asia" },
                2: { text: "Audio" },
                3: { text: "147" },
                4: { text: "126" },
                5: { text: "150" },
                6: { text: "156" },
                7: { text: "" },
                8: { text: "" },
            },
        },
        6: {
            cells: {
                0: { text: "Jan" },
                1: { text: "Asia" },
                2: { text: "Mobile" },
                3: { text: "98" },
                4: { text: "71" },
                5: { text: "120" },
                6: { text: "136" },
                7: { text: "" },
                8: { text: "" },
            },
        },
        7: {
            cells: {
                0: { text: "Feb" },
                1: { text: "Europe" },
                2: { text: "Audio" },
                3: { text: "92" },
                4: { text: "89" },
                5: { text: "115" },
                6: { text: "83" },
                7: { text: "" },
                8: { text: "" },
            },
        },
        8: {
            cells: {
                0: { text: "Feb" },
                1: { text: "Europe" },
                2: { text: "Mobile" },
                3: { text: "122" },
                4: { text: "125" },
                5: { text: "131" },
                6: { text: "119" },
                7: { text: "" },
                8: { text: "" },
            },
        },
        9: {
            cells: {
                0: { text: "Feb" },
                1: { text: "America" },
                2: { text: "Audio" },
                3: { text: "97" },
                4: { text: "126" },
                5: { text: "94" },
                6: { text: "91" },
                7: { text: "" },
                8: { text: "" },
            },
        },
        10: {
            cells: {
                0: { text: "Feb" },
                1: { text: "America" },
                2: { text: "Mobile" },
                3: { text: "135" },
                4: { text: "125" },
                5: { text: "118" },
                6: { text: "161" },
                7: { text: "" },
                8: { text: "" },
            },
        },
        11: {
            cells: {
                0: { text: "Feb" },
                1: { text: "Asia" },
                2: { text: "Audio" },
                3: { text: "115" },
                4: { text: "106" },
                5: { text: "94" },
                6: { text: "151" },
                7: { text: "" },
                8: { text: "" },
            },
        },
        12: {
            cells: {
                0: { text: "Feb" },
                1: { text: "Asia" },
                2: { text: "Mobile" },
                3: { text: "104" },
                4: { text: "127" },
                5: { text: "103" },
                6: { text: "98" },
                7: { text: "Asia mobile shipments delayed by two weeks." },
                8: { text: "" },
            },
        },
        13: {
            cells: {
                0: { text: "Mar" },
                1: { text: "Europe" },
                2: { text: "Audio" },
                3: { text: "140" },
                4: { text: "134" },
                5: { text: "153" },
                6: { text: "159" },
                7: { text: "" },
                8: { text: "" },
            },
        },
        14: {
            cells: {
                0: { text: "Mar" },
                1: { text: "Europe" },
                2: { text: "Mobile" },
                3: { text: "94" },
                4: { text: "77" },
                5: { text: "92" },
                6: { text: "79" },
                7: { text: "" },
                8: { text: "Promo pricing in March." },
            },
        },
        15: {
            cells: {
                0: { text: "Mar" },
                1: { text: "America" },
                2: { text: "Audio" },
                3: { text: "85" },
                4: { text: "80" },
                5: { text: "94" },
                6: { text: "104" },
                7: { text: "" },
                8: { text: "" },
            },
        },
        16: {
            cells: {
                0: { text: "Mar" },
                1: { text: "America" },
                2: { text: "Mobile" },
                3: { text: "176" },
                4: { text: "165" },
                5: { text: "173" },
                6: { text: "186" },
                7: { text: "" },
                8: { text: "" },
            },
        },
        17: {
            cells: {
                0: { text: "Mar" },
                1: { text: "Asia" },
                2: { text: "Audio" },
                3: { text: "124" },
                4: { text: "144" },
                5: { text: "122" },
                6: { text: "130" },
                7: { text: "" },
                8: { text: "" },
            },
        },
        18: {
            cells: {
                0: { text: "Mar" },
                1: { text: "Asia" },
                2: { text: "Mobile" },
                3: { text: "106" },
                4: { text: "90" },
                5: { text: "118" },
                6: { text: "94" },
                7: { text: "" },
                8: { text: "" },
            },
        },
        19: {
            cells: {
                0: { text: "Apr" },
                1: { text: "Europe" },
                2: { text: "Audio" },
                3: { text: "107" },
                4: { text: "123" },
                5: { text: "125" },
                6: { text: "145" },
                7: { text: "" },
                8: { text: "" },
            },
        },
        20: {
            cells: {
                0: { text: "Apr" },
                1: { text: "Europe" },
                2: { text: "Mobile" },
                3: { text: "173" },
                4: { text: "195" },
                5: { text: "185" },
                6: { text: "191" },
                7: { text: "" },
                8: { text: "" },
            },
        },
        21: {
            cells: {
                0: { text: "Apr" },
                1: { text: "America" },
                2: { text: "Audio" },
                3: { text: "135" },
                4: { text: "106" },
                5: { text: "126" },
                6: { text: "136" },
                7: { text: "Forecast raised after the retailer deal in April." },
                8: { text: "" },
            },
        },
        22: {
            cells: {
                0: { text: "Apr" },
                1: { text: "America" },
                2: { text: "Mobile" },
                3: { text: "102" },
                4: { text: "96" },
                5: { text: "111" },
                6: { text: "126" },
                7: { text: "" },
                8: { text: "" },
            },
        },
        23: {
            cells: {
                0: { text: "Apr" },
                1: { text: "Asia" },
                2: { text: "Audio" },
                3: { text: "107" },
                4: { text: "134" },
                5: { text: "82" },
                6: { text: "109" },
                7: { text: "" },
                8: { text: "" },
            },
        },
        24: {
            cells: {
                0: { text: "Apr" },
                1: { text: "Asia" },
                2: { text: "Mobile" },
                3: { text: "139" },
                4: { text: "135" },
                5: { text: "118" },
                6: { text: "178" },
                7: { text: "" },
                8: { text: "" },
            },
        },
    },
};
